import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "Terms and Conditions",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h3: "h3",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Title} = _components;
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: " Terms and Conditions "
    }), "\n", _jsx(_components.p, {
      children: "The Global Education Monitoring Report encourages the use of the Scoping Progress in Education (SCOPE) website for informational purposes only. All contents on this website are protected by copyright. By accessing the website and using any content found therein, you (the “User”) acknowledge that you have fully read and understood, and agree to be bound by, these Terms of Use."
    }), "\n", _jsxs(_components.p, {
      children: ["The information available on this website has been posted with the intent that it be readily available for personal or public non-commercial use and may be reproduced, in part or in whole, and by any means, without charge or further permission unless otherwise specified. All requests for commercial use and translation rights should be submitted to ", _jsx(_components.a, {
        href: "mailto:gemreport@unesco.org",
        children: "gemreport@unesco.org"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "users-are-required-to",
      children: "Users are required to:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Exercise due diligence in ensuring the accuracy of the materials reproduced;"
      }), "\n", _jsx(_components.li, {
        children: "Acknowledge the source prominently alongside the data using the following format:"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Source: (If appropriate \"Adapted from\") GEM Report Scoping Progress in Education (SCOPE) website, ", _jsx(_components.a, {
        href: "https://www.education-progress.org",
        children: "https://www.education-progress.org"
      }), ", date of extraction."]
    }), "\n", _jsx(_components.p, {
      children: "It should be noted that the database is subject to updates and revisions on a regular basis. Therefore, it is important to include the date of extraction when citing data."
    }), "\n", _jsx(_components.h3, {
      id: "licenses",
      children: "Licenses"
    }), "\n", _jsx(_components.p, {
      children: "You are encouraged to use the data to benefit yourself and others in creative ways. You may extract, download and make copies of the information contained in the datasets, and you may share that information with third parties."
    }), "\n", _jsx(_components.h3, {
      id: "no-association-or-endorsement",
      children: "No association or endorsement"
    }), "\n", _jsx(_components.p, {
      children: "The User may neither represent nor imply that the Global Education Monitoring Report has participated in, approved, endorsed or otherwise supported his or her use or reproduction of the Material. The User may not claim any affiliation with Education Progress (or the Global Education Monitoring Report)."
    }), "\n", _jsx(_components.h3, {
      id: "website-links",
      children: "Website links"
    }), "\n", _jsx(_components.p, {
      children: "An external website may include a hyperlink to any page of the SCOPE website without requesting permission. However, this must not infringe on the intellectual property rights of the Global Education Monitoring Report, in particular relating to names, logos, copyright or author’s rights."
    }), "\n", _jsx(_components.h3, {
      id: "disclaimer",
      children: "Disclaimer"
    }), "\n", _jsx(_components.p, {
      children: "The Global Education Monitoring Report maintains this website to enhance public access to data and related information. It makes every effort to ensure, but do not guarantee, the accuracy or completeness of the information on this site. Our goal is to keep this information timely and accurate. If errors are brought to our attention, we seek to correct them."
    }), "\n", _jsx(_components.p, {
      children: "The designations employed and the presentation of the material on this website do not imply the expression of any opinion whatsoever on the part of UNESCO concerning the legal status of any country, territory, city or area, or of its authorities, or concerning the delimitation of its frontiers or boundaries."
    }), "\n", _jsx(_components.p, {
      children: "The Global Education Monitoring Report is responsible for the choice and the presentation of the facts contained on this website, which are not necessarily those of UNESCO and do not commit the Organization."
    }), "\n", _jsx(_components.p, {
      children: "We make every effort to minimise disruption caused by technical errors. However, some data or information on the website may have been created or structured in files or formats which are not error-free and we cannot guarantee that our service will not be interrupted or otherwise affected by such problems. The Global Education Monitoring Report accepts no responsibility with regard to such problems (failure of performance, computer virus, communication line failure, alteration of content, etc.) incurred as a result of using the Education Progress website or any link to external sites."
    }), "\n", _jsx(_components.h3, {
      id: "privacy",
      children: "Privacy"
    }), "\n", _jsx(_components.p, {
      children: "By accessing the SCOPE website, certain information, such as Internet protocol (IP) addresses, navigation behaviour through the website, the software used and the time spent, along with other similar information, will be stored on our servers. This information will not specifically identify you and will be used for website traffic analysis."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
